import React from 'react';

interface Props {
    initialPageSize: number;
    handleChange: (event: React.ChangeEvent) => void;
}

export default function PageSizeSelector({ initialPageSize, handleChange }: Props) {
    const pageSizes = [5, 10, 20, 50, 100, 500];

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <span className='text-muted' style={{ lineHeight: 3 }}>
                Mostrar{' '}
            </span>
            &nbsp;
            <select
                style={{ maxWidth: 55, borderRadius: 15 }}
                className='form-control search text-muted'
                onChange={handleChange}
                value={initialPageSize}
            >
                {pageSizes.map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                        {pageSize}
                    </option>
                ))}
            </select>
            <span className='text-muted' style={{ lineHeight: 3 }}>
                &nbsp;resultados{' '}
            </span>
            &nbsp;
        </div>
    );
}
